//lib
import { useLocation, useNavigate } from "react-router-dom";

//redux

//component
import Row from "../element/row";
import Col from "../element/col";

import Icon from "../element/icon";
import { useTranslation } from "react-i18next";

export default function BottomNavBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  // const { menuList } = useSelector((state) => state.common);

  const navList = [
    {
      label: "Discover",
      icon: "mingcute:car-2-line",
      path: "/",
    },
    {
      label: "Consign",
      icon: "material-symbols:car-tag-outline",
      path: "/consign",
    },
    {
      label: "Workshop",
      icon: "ph:house-bold",
      path: "/workshop",
    },
    {
      label: "Profile",
      icon: "ri:account-pin-circle-line",
      path: "/profile",
    },
  ];

  return (
    <nav className="fixed-bottom bottom-navbar">
      <Row className="_row navbar-list justify-between">
        {navList.map((nav, navIndex) => (
          <Col
            className={`_col navbar-item ${
              pathname == nav.path ? "active" : ""
            } pointer`}
            key={navIndex}
            onClick={() => {
              navigate(nav.path);
            }}
          >
            <Icon icon={nav.icon} className="_svg" />
            <p className="_label nav-label">{t(nav.label)}</p>
          </Col>
        ))}
      </Row>
    </nav>
  );
}
